import { render } from "./IconVolunteer.vue?vue&type=template&id=d6f416f2"
import script from "./IconVolunteer.vue?vue&type=script&lang=js"
export * from "./IconVolunteer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__